import { render, staticRenderFns } from "./AppSearchBar.vue?vue&type=template&id=dcbc72e0&"
import script from "./AppSearchBar.vue?vue&type=script&lang=js&"
export * from "./AppSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports